import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-spinner-v2',
  templateUrl: './lib-spinner-v2.component.html',
  styleUrls: ['./lib-spinner-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibSpinnerV2Component {
  @Input() imageUrl: string;
  @Input() isSmall: boolean;

  getStyle(): object {
    if (!this.imageUrl) {
      return;
    }

    const bg = 'url("' + this.imageUrl + '")';
    return {
      background: bg,
      'background-repeat': 'no-repeat',
      'background-position': 'center center',
      'background-size': '50%',
    };
  }
}
